import { ColumnsDesktopLayout } from 'src/interfaces/PageColumn';

interface ColumnDistributionOption {
  id: ColumnsDesktopLayout;
  spans: number[];
  labelKey: string;
}

const TWO_COL: ColumnDistributionOption[] = [
  { id: 'equal', spans: [6, 6], labelKey: 'columnsDist2Equal' },
  { id: '2-25-75', spans: [3, 9], labelKey: 'columnsDist2_25_75' },
  { id: '2-75-25', spans: [9, 3], labelKey: 'columnsDist2_75_25' },
  { id: '2-66-33', spans: [8, 4], labelKey: 'columnsDist2_66_33' },
  { id: '2-33-66', spans: [4, 8], labelKey: 'columnsDist2_33_66' },
];

const THREE_COL: ColumnDistributionOption[] = [
  { id: 'equal', spans: [4, 4, 4], labelKey: 'columnsDist3Equal' },
  { id: '3-25-50-25', spans: [3, 6, 3], labelKey: 'columnsDist3_25_50_25' },
];

const FOUR_COL: ColumnDistributionOption[] = [
  { id: 'equal', spans: [3, 3, 3, 3], labelKey: 'columnsDist4Equal' },
  { id: '4-50-25-25', spans: [6, 2, 2, 2], labelKey: 'columnsDist4_50_25_25' },
  { id: '4-25-25-50', spans: [2, 2, 2, 6], labelKey: 'columnsDist4_25_25_50' },
  { id: '4-wide-sides', spans: [4, 2, 2, 4], labelKey: 'columnsDist4WideSides' },
];

const DISTRIBUTION_OPTIONS_BY_COUNT: Record<2 | 3 | 4, ColumnDistributionOption[]> = {
  2: TWO_COL,
  3: THREE_COL,
  4: FOUR_COL,
};

/** Maps legacy `wideCenter` to the canonical distribution id. */
export function canonicalDesktopLayout(
  layout: ColumnsDesktopLayout | undefined,
): ColumnsDesktopLayout {
  if (layout === 'wideCenter') return '3-25-50-25';
  return layout ?? 'equal';
}

export function distributionOptionsForCount(columnCount: number): ColumnDistributionOption[] {
  const n = Math.min(4, Math.max(2, columnCount)) as 2 | 3 | 4;
  return DISTRIBUTION_OPTIONS_BY_COUNT[n];
}

export function normalizeDesktopColumnLayout(
  columnCount: number,
  raw?: ColumnsDesktopLayout,
): ColumnsDesktopLayout {
  const layout = canonicalDesktopLayout(raw);
  if (layout === 'equal') return 'equal';
  const valid = distributionOptionsForCount(columnCount).some(o => o.id === layout);
  return valid ? layout : 'equal';
}

export function distributionSpans(
  columnCount: number,
  layout: ColumnsDesktopLayout | undefined,
): number[] | null {
  const canonical = normalizeDesktopColumnLayout(columnCount, layout);
  if (canonical === 'equal') return null;
  const option = distributionOptionsForCount(columnCount).find(o => o.id === canonical);
  return option?.spans ?? null;
}
